import * as AppConfig from "../../app/config/constants";
import axios from "axios";


class CostEstimateApi {
    constructor(token) {
        this.auth_token = token
    }

    headers() {
        return {
            "x-api-key": this.auth_token,
            "Content-Type": "application/json",
        }
    }

    async get(uri_suffix) {
        const uri = AppConfig.COST_ESTIMATE_API_BASE_URI + uri_suffix;
        const res = await axios.get(uri, {headers: this.headers()})
        return res.data
    }

    async post(uri_suffix, data) {
        const uri = AppConfig.COST_ESTIMATE_API_BASE_URI + uri_suffix;
        const res = await axios.post(uri, data,{headers: this.headers()})
        return res.data
    }
}

export default CostEstimateApi
